/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для таймера обратного отсчета.
   */
  app.CountdownView = app.View.extend({
    additionalOptions: ['expirationPeriod'],
  
    run: function (options) {
      if (options && options.inSeconds){
        this.delay = 1000;
        this.inSeconds = true;
      } else {
        this.delay = 1000 * 60;
        this.inSeconds = false;
      }
      this.countdown(this.expirationPeriod);
    },
  
    /**
     * Запустить счетчик, если время не истекло запустится снова через this.delay
     * @param expirationPeriod {number} оставшееся время в мс
     */
    countdown: function (expirationPeriod) {
      if (expirationPeriod <= 0) {
        this.$el.hide();
        return;
      }
      this.update(expirationPeriod);
      setTimeout(this.countdown.bind(this, expirationPeriod - this.delay), this.delay);
    },
  
    /**
     * Обновление в соответсвии с оставшимся временем
     * @param expirationPeriod {number} оставшееся время в мс
     */
    update: function (expirationPeriod) {
      var time,
        days,
        hours,
        minutes,
        seconds;
  
      days = Math.floor(expirationPeriod / (24 * 60 * 60 * 1000));
      hours = Math.floor(expirationPeriod / (60 * 60 * 1000)) % 24;
      minutes = Math.floor(expirationPeriod / (60 * 1000)) % 60;
      seconds = Math.floor(expirationPeriod / 1000) % 60;
  
      time = {
        days: app.helpers.NumberHelper.digitsNumberArray(days, 2),
        daysName: app.helpers.DeclinationHelper.format(days, ['день', 'дня', 'дней']),
        hours: app.helpers.NumberHelper.digitsNumber(hours, 2),
        hoursName: app.helpers.DeclinationHelper.format(hours, ['час', 'часа', 'часов']),
        minutes: app.helpers.NumberHelper.digitsNumber(minutes, 2),
        minutesName: app.helpers.DeclinationHelper.format(minutes, ['минута', 'минуты', 'минут']),
      };
  
      if (this.inSeconds) {
        time.seconds = app.helpers.NumberHelper.digitsNumber(seconds, 2);
        time.secondsName = app.helpers.DeclinationHelper.format(seconds, ['секунда', 'секунды', 'секунд']);
      }
      this.render(time);
    },
  });
})(jQuery);

}.call(window));